module.exports = __webpack_public_path__ + "static/img/basil.b22c630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/basil.jpg
// module id = B9Ve
// module chunks = 1